import _Quill from 'quill';
import quillEditor from './editor.vue';

const Quill = _Quill;
const install = (Vue: any, globalOptions: any) => {
  if (globalOptions) {
    quillEditor.props.globalOptions.default = () => globalOptions;
  }
  Vue.component(quillEditor.name, quillEditor);
};

const VueQuillEditor = { Quill, quillEditor, install };

export default VueQuillEditor;
export { Quill, quillEditor, install };
